import { Card, Row, Col, Typography } from "antd";
import { 
  MedicineBoxOutlined, 
  ScissorOutlined, 
  SmileOutlined, 
  ShopOutlined,
  HeartOutlined,
  SkinOutlined,
  EyeOutlined
} from "@ant-design/icons";
const { Title, Text } = Typography;

const businessIcons = {
  clinic: <MedicineBoxOutlined className="business-icon" />,
  saloon: <ScissorOutlined className="business-icon" />,
  dentist: <SmileOutlined className="business-icon" />,
  hospital: <HeartOutlined className="business-icon" />,
  dermatology: <SkinOutlined className="business-icon" />,
  ophthalmology: <EyeOutlined className="business-icon" />,
};

export default function BusinessTypeList({
  typeOfBusinesses,
  setSelectedBusinessType,
}) {
  return (
    <div className="business-type-container">
      <Title level={4} className="section-title">
        Select Business Type
      </Title>
      <div className="scrollable-row-container">
        <Row gutter={[0, 0]} justify="center" className="scrollable-row1">
          {typeOfBusinesses.map((business) =>
            business.value === "other" ? null : (
              <Col xs={12} sm={8} md={6} lg={4} key={business.value}>
                <Card
                  className="business-type-card"
                  onClick={() => setSelectedBusinessType(business.value)}
                  hoverable
                >
                  <div className="card-content1">
                    {businessIcons[business.value] || <ShopOutlined className="business-icon" />}
                    <Text strong className="business-title">
                      {business.title}
                    </Text>
                  </div>
                </Card>
              </Col>
            )
          )}
        </Row>
      </div>
    </div>
  );
}